import validate from "/home/node/app/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.13.9_db0@0.3.1_eslint@9.21.0_jiti@2.4._a52a08763c51121e4dcdb6b75b8390b1/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45persist_45utm_45global from "/home/node/app/rdp-employee/middleware/00.persist-utm.global.ts";
import _01_45admin_45order_45init_45global from "/home/node/app/rdp-employee/middleware/01.admin-order-init.global.ts";
import _02_45gift_45init_45global from "/home/node/app/rdp-employee/middleware/02.gift-init.global.ts";
import _03_45partner_45init_45global from "/home/node/app/rdp-employee/middleware/03.partner-init.global.ts";
import _04_45login_45guest_45global from "/home/node/app/rdp-employee/middleware/04.login-guest.global.ts";
import lens_45step_45global from "/home/node/app/rdp-employee/middleware/lens-step.global.ts";
import manifest_45route_45rule from "/home/node/app/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.13.9_db0@0.3.1_eslint@9.21.0_jiti@2.4._a52a08763c51121e4dcdb6b75b8390b1/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _00_45persist_45utm_45global,
  _01_45admin_45order_45init_45global,
  _02_45gift_45init_45global,
  _03_45partner_45init_45global,
  _04_45login_45guest_45global,
  lens_45step_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}